<mat-toolbar color="primary">
  <span>Ivar</span>
  <div class="toolbar-spacer flex-grow-1"></div>
  <app-auth-toolbar></app-auth-toolbar>
</mat-toolbar>
